import api from "../axiosIntercepture";

export const fetchReturnMD = async (page, limit) => {

    const res = await api.post("/returnmd/fetch", {
        page: page + 1,
        limit
    })

    return res.data.data
}


export const fetchCategorySubCategory = async () => {

    const res = await api.post("returnmd/category-list");

    return res.data.data;

};

export const createReturnMD = async (data) => {

    const res = await api.post("/returnmd/create", data)

    return res.data
}

export const updateReturnMD = async (id, data) => {

    const res = await api.post(`/returnmd/update/${id}`, data)

    return res.data
}